
interface ISkeletonBoxProps {
  height?: number;
  width?: number;
};

export const SkeletonBox = ({ height = 300, width = 0 }: ISkeletonBoxProps) => {
  return (
    <div className="flex-grow space-y-2" aria-hidden="true">
            <div className={`bg-muted animate-pulse`} style={width ? {width:`${width}px`, height:`${height}px`}: {height:`${height}px`}}></div>
    </div>);
};